<template>
    <div v-if="isLoading" class="overlay-loader fixed inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center z-50">
    <div class="loader loader--style8" title="Loading">
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="40px"
        height="50px"
        viewBox="0 0 24 30"
        style="enable-background:new 0 0 50 50;"
        xml:space="preserve"
      >
        <rect x="0" y="10" width="4" height="10" class="gradient-bar">
          <animate
            attributeName="opacity"
            attributeType="XML"
            values="0.2; 1; .2"
            begin="0s"
            dur="0.6s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="height"
            attributeType="XML"
            values="10; 20; 10"
            begin="0s"
            dur="0.6s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="y"
            attributeType="XML"
            values="10; 5; 10"
            begin="0s"
            dur="0.6s"
            repeatCount="indefinite"
          />
        </rect>
        <rect x="8" y="10" width="4" height="10" class="gradient-bar">
          <animate
            attributeName="opacity"
            attributeType="XML"
            values="0.2; 1; .2"
            begin="0.15s"
            dur="0.6s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="height"
            attributeType="XML"
            values="10; 20; 10"
            begin="0.15s"
            dur="0.6s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="y"
            attributeType="XML"
            values="10; 5; 10"
            begin="0.15s"
            dur="0.6s"
            repeatCount="indefinite"
          />
        </rect>
        <rect x="16" y="10" width="4" height="10" class="gradient-bar">
          <animate
            attributeName="opacity"
            attributeType="XML"
            values="0.2; 1; .2"
            begin="0.3s"
            dur="0.6s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="height"
            attributeType="XML"
            values="10; 20; 10"
            begin="0.3s"
            dur="0.6s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="y"
            attributeType="XML"
            values="10; 5; 10"
            begin="0.3s"
            dur="0.6s"
            repeatCount="indefinite"
          />
        </rect>
      </svg>
    </div>
  </div> 
    <div  :class="['relative', (isMobile || isBig) ? 'p-[1rem] pt-[3.5rem]' : 'p-[4rem]']"  v-if="!alreadyConnected">
      <div class="header flex justify-between items-center mb-6" >
          <button class="flex items-center text-blue-500 font-semibold">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
            </svg>
            <span class="ml-2 text-return" @click="goToPreviousStep">{{ $t('MainLayout.retour') }}</span>
          </button>
          <div :class="['absolute ', (isMobile) ? 'top-10 right-0 z-10 ' : 'top-8 right-8 z-10 ']" >
              <div 
                  class="bg-white custom-border text-blue-700 px-4 py-1 rounded-full flex items-center shadow-md cursor-pointer"
                  @click="toggleLanguageDropdown"
              >
                  <img :src="currentFlag" alt="Langue" class="w-8 h-8 mr-2" />
                  <i class="fas fa-chevron-down"></i>
              </div>

                <div 
                  v-if="showLanguageDropdown" 
                  class="absolute right-0 mt-2 bg-white shadow-lg rounded-lg p-2 w-32"
                >
                  <button
                  @click="setLanguage('fr')"
                  class="flex items-center justify-start w-full px-2 py-1 hover:bg-blue-100 rounded-md transition"
                  >
                  <img src="../../assets/france-flag.png" alt="Français" class="w-6 h-6 mr-2" />
                  Français
                  </button>
                  <button
                  @click="setLanguage('en')"
                  class="flex items-center justify-start w-full px-2 py-1 hover:bg-blue-100 rounded-md transition"
                  >
                  <img src="../../assets/uk-flag.png" alt="English" class="w-6 h-6 mr-2" />
                  English
                  </button>
              </div>
            </div>
        </div>


        <div
          class="title-checkout mt-7 mx-auto"
          :class="{
            'w-[70%]': !isBig,
            'w-[90%]':  isBig
          }"
        >
      {{ $t('inscrit.title') }}
    </div>

    <div class="title-checkout-light mt-7 mx-auto"  :class="{
      'w-[70%]': !isBig,
      'w-[90%]': isBig
    }">
      {{ $t('inscrit.text') }}
    </div>

    <div class="immediate-section mt-[3rem] mx-auto"  :class="{
            'w-[70%]': !isBig,
            'w-[90%]': isBig
          }">
      <div class="grid grid-cols-2 gap-8 p-2">
        <div>
          <label for="prenom" class="block label-checkout">{{ $t('inscrit.prenom') }}</label>
          <input
            id="prenom"
            type="text"
            placeholder="Prénom"
            class="mt-1 block w-full p-3 border border-checkout rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 custom-placeholder"
          />
        </div>

        <div>
          <label for="nom" class="block label-checkout">{{ $t('inscrit.nom') }}</label>
          <input
            id="nom"
            type="text"
            placeholder="Nom"
            class="mt-1 block w-full p-3 border border-checkout rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 custom-placeholder"
          />
        </div>

        <div class="col-span-2">
          <label for="entreprise" class="block label-checkout">{{ $t('inscrit.entreprise') }}</label>
          <input
            id="entreprise"
            type="text"
            placeholder="Entreprise"
            class="mt-1 block w-full p-3 border border-checkout rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 custom-placeholder"
          />
        </div>

        <div class="col-span-2">
          <label for="email" class="block label-checkout">{{ $t('inscrit.email') }}</label>
          <input
            id="email"
            type="email"
            placeholder="Email"
            class="mt-1 block w-full p-3 border border-checkout rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 custom-placeholder"
          />
        </div>

        <div class="col-span-2 relative">
          <label for="password" class="block label-checkout">{{ $t('inscrit.password') }}</label>
          <div class="relative">
            <input
              id="password"
              :type="showPassword ? 'text' : 'password'"
              placeholder="*********"
              class="mt-1 block w-full p-3 border border-checkout rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 custom-placeholder pr-10"
            />

            <i v-if="showPassword" class="fa-solid fa-eye-slash absolute top-[1rem] right-3 flex items-center z-[99999]" @click="togglePassword" style="
                  margin-left: 8px; 
                  background: var(--gradient, linear-gradient(90deg, #1E93FD 0%, #3154C8 100%)); 
                  -webkit-background-clip: text; 
                  -webkit-text-fill-color: transparent; 
                  cursor: pointer;
                "></i>

              <i v-else class="fa-solid fa-eye absolute top-[1rem] right-3 flex items-center z-[99999]" @click="togglePassword" style="
                margin-left: 8px; 
                background: var(--gradient, linear-gradient(90deg, #1E93FD 0%, #3154C8 100%)); 
                -webkit-background-clip: text; 
                -webkit-text-fill-color: transparent; 
                cursor: pointer;
              "></i>

          </div>
        </div>


        <!-- Bouton de soumission -->
        <div class="col-span-2 flex justify-end mt-4">
          <button
            type="submit"
            class="button-continu text-[20px] text-white px-8 py-3 rounded-full font-semibold w-4/5 mx-auto"
            @click="submitPayment"
            :disabled="isLoading"
            >
            {{ $t('inscrit.register') }}
          </button>
        </div>
      </div>
    </div>

    <div class="info-section mt-[3rem] mx-auto" :class="{
      'w-[70%]': !isBig,
      'w-[90%]': isBig
    }">
      <ul class="space-y-3">
        <li class="flex items-center">
          <span class="text-lg mr-3">➝</span>
          {{ $t('inscrit.text2') }}
        </li>
        <li class="flex items-center">
          <span class="text-lg mr-3">➝</span>
          {{ $t('inscrit.text3') }}
        </li>
        <li class="flex items-center">
          <span class="text-lg mr-3">➝</span>
          {{ $t('inscrit.text4') }}
        </li>
        <li class="flex items-center">
          <span class="text-lg mr-3">➝</span>
          {{ $t('inscrit.text5') }}
        </li>
      </ul>
    </div>

    
  </div>

  <div 
    v-if="showToast" 
    class="fixed top-5 left-1/2 transform -translate-x-1/2 px-6 py-3 text-white font-semibold rounded-lg shadow-lg transition-opacity duration-300 bg-red-500"
    style="z-index: 9999;"
  >
    {{ toastMessage }}
  </div>

</template>


 <script>
import axios from '../../plugins/axios';
import franceFlag from '../../assets/france-flag.png';
import ukFlag from '../../assets/uk-flag.png';


export default {
  name: 'CheckoutViewV3',
  data() {
    return {
      alreadyConnected: false,
      addons: [],
      selectedAddons: [],
      showPassword: false,
      paymentData: null,
      isLoading: false,
      isSummaryLoading: true, 
      showPaymentDetails: false,
      showToast: false,
      flags: {
        fr: franceFlag,
        en: ukFlag,
      },
      currentLanguage: localStorage.getItem('langue') || navigator.language,
      showLanguageDropdown: false,
      isMobile: false,
      isBig: false,
      name: "",
      showRecurringDetails: false,
      summaryData: {
        immediate: {
          subtotal: '0.00',
          vat: '0.00',
          total: '0.00',
          currency: 'eur',
          items: [],
        },
        recurring: {
          subtotal: '0.00',
          vat: '0.00',
          total: '0.00',
          currency: 'eur',
          items: [],
        },
      },
    };
  },
  computed: {
    currentFlag() {
      const languageKey = this.currentLanguage.split('-')[0];
      return this.flags[languageKey] || this.flags.en;
    },
  },
   methods: {
    showToastMessage(message) {
      this.toastMessage = message;
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
        this.toastMessage = '';
      }, 5000); 
    },
    async hashEmail(email) {
      const encoder = new TextEncoder();
      const data = encoder.encode(email);
      const hashBuffer = await crypto.subtle.digest("SHA-256", data);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      return hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
    },
    async submitPayment() {
      try {
        this.isLoading = true;
        localStorage.setItem('subscriptwithoutpay', true);

        const prenom = document.getElementById('prenom').value.trim();
        const nom = document.getElementById('nom').value.trim();
        const email = document.getElementById('email').value.trim();
        const entreprise = document.getElementById('entreprise').value.trim();
        const password = document.getElementById('password').value.trim();

        const utmParams = this.getUTMFromCookies();

        const response = await axios.post('/api/offline-checkout', {
          prenom,
          nom,
          email,
          entreprise,
          password,
          paymentData: this.paymentData,
          currentLanguage: this.currentLanguage,
          utm_source: utmParams.utm_source || null,
          utm_medium: utmParams.utm_medium || null,
          utm_campaign: utmParams.utm_campaign || null,
          utm_content: utmParams.utm_content || null,
        });
        
        const hashedEmail = await this.hashEmail(email);
        localStorage.setItem("email_checkout", email);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'sign_up',
          method: "email",
          email: hashedEmail, 
        });

        if (response.data.url) {
          const { url, token } = response.data;
          localStorage.setItem('token_checkout', token);
          localStorage.setItem('name', prenom);
          const currentStep = 8;
          localStorage.setItem('currentStep', currentStep);
          const stepEvent = new StorageEvent('storage', {
            key: 'currentStep',
            newValue: currentStep.toString(),
          });
          window.dispatchEvent(stepEvent);

          window.location.href = url;
        } else {
          this.showToastMessage()
          alert("Erreur : impossible d'accéder à Stripe Checkout.");
        }
      } catch (error) {
        console.error("Erreur lors de la requête offline-checkout :", error);
        let message;
        if (error.response && error.response.data && error.response.data.errorCode) {
          message = this.$t(`errorCodes.${error.response.data.errorCode}`);
        } else {
          message = this.$t('errorCodes.1');
        }

        this.showToastMessage(message);

      } finally {
        this.isLoading = false;
      }
    },
    toggleRecurringDetails() {
      this.showRecurringDetails = !this.showRecurringDetails;
    },
    getAddonLogo(key) {
      return this.addontable[key] || null; 
    },
    updateIsMobile() {
        this.isMobile = window.innerWidth <= 768; 
        this.isBig = window.innerWidth <= 1700; 
    },
    goToPreviousStep() {
        const currentStep = 2;

        localStorage.setItem('currentStep', currentStep);

        const stepEvent = new StorageEvent('storage', {
          key: 'currentStep',
          newValue: currentStep.toString(),
        });
        window.dispatchEvent(stepEvent);
        localStorage.removeItem('paymentDataFull');
        const storageEvent = new StorageEvent('storage', {
          key: "paymentDataFull",       
          oldValue: localStorage.getItem("paymentDataFull"), 
          newValue: null,         
          storageArea: localStorage,
        });

        window.dispatchEvent(storageEvent);


       this.$router.push('/subscribe/v2');
     },
     togglePassword() {
      this.showPassword = !this.showPassword;
    },

    getUTMFromCookies() {
        const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
        let utmData = {};

        utmParams.forEach(param => {
            const regex = new RegExp('(^|; )' + param + '=([^;]*)');
            const match = document.cookie.match(regex);
            if (match) {
                utmData[param] = decodeURIComponent(match[2]);
            }
        });

        return utmData;
    },

    toggleLanguageDropdown() {
      this.showLanguageDropdown = !this.showLanguageDropdown;
    },
    setLanguage(lang) {
      this.currentLanguage = lang;
      this.$i18n.locale = lang;
      this.showLanguageDropdown = false;
      localStorage.setItem('langue', lang)
      localStorage.setItem('lang', lang);
    },
  },
  created() {
    const storedPaymentData = localStorage.getItem('paymentDataFull');
    if (storedPaymentData) {
      const data = JSON.parse(storedPaymentData);
      this.paymentData = data;
    } else {
      console.error('Aucune donnée de paiement trouvée.');
      const currentStep = 1;

      localStorage.setItem('currentStep', currentStep);

      const stepEvent = new StorageEvent('storage', {
        key: 'currentStep',
        newValue: currentStep.toString(),
      });

      window.dispatchEvent(stepEvent);
      this.$router.push('/subscribe/v1');
      return;
    }
  },
  mounted() {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    document.head.appendChild(meta);
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile);
    const storedPaymentData = localStorage.getItem('paymentDataFull');
    if (storedPaymentData) {
      const data = JSON.parse(storedPaymentData);
      this.paymentData = data;
    }
    if (!this.paymentData) {
      console.error('Aucune donnée de paiement trouvée.');
      const currentStep = 1;

      localStorage.setItem('currentStep', currentStep);

      const stepEvent = new StorageEvent('storage', {
        key: 'currentStep',
        newValue: currentStep.toString(),
      });

      window.dispatchEvent(stepEvent);
      this.$router.push('/subscribe/v1');
      return;
    }
    if(localStorage.getItem('token_checkout')){
      this.$router.push('/subscribe/confirm');
      return;
    }
    const storedItems = JSON.parse(localStorage.getItem('itemsDatalayer')) || [];
    const totalValue = storedItems.reduce((sum, item) => sum + (item.value || 0), 0);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'begin_checkout',
      currency: this.paymentData.currency,
      value: totalValue, 
      items: JSON.parse(localStorage.getItem('itemsDatalayer'))
    });
  },
  
};

 </script>
 

  <style scoped>

  .button-continu {
      width: 50%;
      background: linear-gradient(90deg, #1E93FD 0%, #3154C8 100%);
      box-shadow: 0 4px 10px rgba(30, 147, 253, 0.3);
      transition: background 1s ease, box-shadow 1s ease; 
    }

    .button-continu:hover {
      background: linear-gradient(90deg, #3154C8 0%, #3154C8 100%);
      box-shadow: 0 4px 10px rgba(30, 147, 253, 0.3);
    }
    .text-sm-payment{
      color: #000;
      font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 200%; 
    }
    .fade-enter-active,
      .fade-leave-active {
        transition: opacity 0.5s;
      }
      .fade-enter,
      .fade-leave-to {
        opacity: 0;
      }
      .step-circle {
        transition: background-color 0.3s, border-color 0.3s;
      }
      .text-lg {
        transition: color 0.3s;
      }
      .payment-summary{
        background: #0E51AC;
      }

      .monthy-price{
        border-radius: 4px;
        background: #083879;
      }

      .quantity-display{
        border-radius: 5px;
        background: #1E93FD;
      }


      .payment-footer {
        background: #EFEFEF;
        padding: 12px 24px; 
        border-radius: 8px; 
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1); 
      }

      .payment-text {
        color: #707070;
        font-family: Montserrat;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

      .stripe-logo {
        font-weight: bold; 
        font-size: 17px;
        font-weight: 700;
      }

      .info-section{
        padding: 2rem;
        border-radius: 10px;
        background: var(--gradient, linear-gradient(90deg, #1E93FD 0%, #3153C7 100%));
        color: #FFF;
        font-family: Montserrat;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 182.24%;
      }

        .immediate-section,
        .recurring-section {
          border-radius: 10px;
          padding: 2rem;
          background: #fff;
          box-shadow: 0px 20px 40px rgba(30, 147, 253, 0.2);
        }

    

        .immediate-items li,
        .recurring-items li {
        padding: 12px 0;
        font-family: Montserrat, sans-serif;
        }

        .immediate-items li:last-child,
        .recurring-items li:last-child {
        border-bottom: none;
        }

        .custom-border{
          border-radius: 62px;
          border: 1px solid var(--gradient, #1E93FD);
        }

        .title-payment{
          color: #000;
          font-family: Montserrat;
          font-size: 25px;
          font-style: normal;
          font-weight: 700;
          line-height: 140%; 
          align-self: stretch;
        }

        .title-recap {
          color: #000;
          font-family: Montserrat;
          font-size: 24px;
          font-style: normal;
          font-weight: 700;
          line-height: 140%; 
        }


        .total-sum{
          text-align: right;
          font-family: Montserrat;
          font-size: 2rem;
          font-style: normal;
          width: 50%;
          font-weight: 700;
          line-height: 140%; 
          background: var(--gradient, linear-gradient(90deg, #1E93FD 0%, #3154C8 100%));
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .fade-enter-active,
        .fade-leave-active {
          transition: opacity 0.7s ease-out;
        }

        .fade-enter-from,
        .fade-leave-to {
          opacity: 0;
        }

        .text-summery{
          color: #000;
          font-family: Montserrat;
          font-size: 32px;
          font-style: normal;
          font-weight: 700;
          line-height: 140%; 
        }

        .payment-month{
          padding: 4px 10px;
          border-radius: 4px;
          background: #083879;
          color: #FFF;
          font-family: Montserrat;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
        }

        .payment-month span{
          font-weight: 700;
        }

        .text-profil{
          color: #000;
          font-family: Montserrat;
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: 140%; 
        }

        .button-details-payment{
          display: flex;
          padding: 14px 22px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          border-radius: 50px;
          background: linear-gradient(90deg, #1E93FD 0%, #3153C7 100%);
          color: #FFF;
          font-family: Montserrat;
          font-size: 12px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          text-transform: uppercase;
          transition: all 0.3s ease-in-out;
        }

        .button-details-payment:hover {
          opacity: 0.9;
          transform: scale(1.05); 
        }

        @media (max-width: 768px) {
          .immediate-section,
          .recurring-section {
            padding: 1rem;
          }

          .title-payment,
          .title-recap {
            font-size: 1rem;
          }

          .total-sum {
            font-size: 1rem;
          }

          .text-summery {
            font-size: 1.5rem;
          }

          .payment-month {
            font-size: 0.75rem;
          }

          .button-details-payment {
            font-size: 0.75rem;
          }

          .button-continu{
            font-size: 0.7rem;
            width: 90%;
          }
        }


        .loading-animation {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  height: 20px;
}

.responsive-svg{
  width: 2vw;
}

.loading-animation {
  width: 20px;
  height: 20px;
  background-color: #1E93FD;
  border-radius: 2px;
  animation: loading-spin 1.2s infinite ease-in-out;
}

.loading-animation:nth-child(1) {
  animation-delay: 0s;
}
.loading-animation:nth-child(2) {
  animation-delay: 0.2s;
}
.loading-animation:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes loading-spin {
  0% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
  50% {
    transform: scale(1.5) rotate(180deg);
    opacity: 0.5;
  }
  100% {
    transform: scale(1) rotate(360deg);
    opacity: 1;
  }
}

.overlay-loader {
  position: fixed; 
  top: 0;
  left: 0;
  width: 120%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); 
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; 
}

.loader {
  color: #1E93FD;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gradient-bar {
  fill: var(--gradient, #3154C8);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}



.button-details-payment-arrow {
  position: relative; 
}

.button-details-payment-arrow::after {
  content: '';
  display: inline-block;
  margin-left: 6px;  
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #FFF;
}


.title-checkout{
  color: #000;
  font-family: Montserrat;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; 
}

.title-checkout-light{
  color: #000;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.label-checkout{
  color: #000;
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  margin-bottom: 15px;
}


.custom-placeholder{
  color: #000;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; 
}

.border-checkout{
  border-radius: 5px;
  border: 1px solid #1E93FD;
}
        
  </style>
  